'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLiveCasinoV2 = exports.getLiveCasino = exports.getTopGamesUWC = exports.getTopGamesWager = exports.getTopGames = exports.getJackpots = exports.getRecentSignIns = exports.getRecentSignUps = exports.getRecentWinById = exports.getRecentWins = exports.getRecentGames = exports.getRecentDeposits = undefined;

var _event = require('tg-core-api/lib/event');

var _event2 = _interopRequireDefault(_event);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRecentDeposits = exports.getRecentDeposits = function getRecentDeposits(limit) {
  return (0, _action.makeApiCallAction)('GET_RECENT_DEPOSITS', _event2.default.getRecentDeposits, limit);
};

var getRecentGames = exports.getRecentGames = function getRecentGames(limit) {
  return (0, _action.makeApiCallAction)('GET_RECENT_GAMES', _event2.default.getRecentGames, limit);
};

var getRecentWins = exports.getRecentWins = function getRecentWins() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return (0, _action.makeApiCallAction)('GET_RECENT_WINS', _event2.default.getRecentWins, limit, threshold);
};

var getRecentWinById = exports.getRecentWinById = function getRecentWinById(gameId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return (0, _action.makeApiCallAction)('GET_RECENT_WIN_BY_ID', _event2.default.getRecentWinById, gameId, limit, threshold);
};

var getRecentSignUps = exports.getRecentSignUps = function getRecentSignUps(limit) {
  return (0, _action.makeApiCallAction)('GET_RECENT_SIGNUPS', _event2.default.getRecentSignUps, limit);
};

var getRecentSignIns = exports.getRecentSignIns = function getRecentSignIns(limit) {
  return (0, _action.makeApiCallAction)('GET_RECENT_SIGNINS', _event2.default.getRecentSignIns, limit);
};

var getJackpots = exports.getJackpots = function getJackpots(currency) {
  return (0, _action.makeApiCallAction)('GET_JACKPOTS', _event2.default.getJackpots, currency);
};

var getTopGames = exports.getTopGames = function getTopGames(limit) {
  return (0, _action.makeApiCallAction)('GET_TOP_GAMES', _event2.default.getTopGames, limit);
};

var getTopGamesWager = exports.getTopGamesWager = function getTopGamesWager(limit) {
  return (0, _action.makeApiCallAction)('GET_TOP_GAMES_WAGER', _event2.default.getTopGamesWager, limit);
};

var getTopGamesUWC = exports.getTopGamesUWC = function getTopGamesUWC(limit) {
  return (0, _action.makeApiCallAction)('GET_TOP_GAMES_UWC', _event2.default.getTopGamesUWC, limit);
};

var getLiveCasino = exports.getLiveCasino = function getLiveCasino() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$gameIds = _ref.gameIds,
      gameIds = _ref$gameIds === undefined ? null : _ref$gameIds,
      _ref$tableIds = _ref.tableIds,
      tableIds = _ref$tableIds === undefined ? null : _ref$tableIds;

  return (0, _action.makeApiCallAction)('GET_LIVE_CASINO', _event2.default.getLiveCasino, gameIds, tableIds);
};

var getLiveCasinoV2 = exports.getLiveCasinoV2 = function getLiveCasinoV2() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _action.makeApiCallAction)('GET_LIVE_CASINO_V2', _event2.default.getLiveCasinoV2, data);
};

exports.default = {
  getRecentDeposits: getRecentDeposits,
  getRecentGames: getRecentGames,
  getRecentWins: getRecentWins,
  getRecentWinById: getRecentWinById,
  getRecentSignUps: getRecentSignUps,
  getRecentSignIns: getRecentSignIns,
  getTopGames: getTopGames,
  getTopGamesWager: getTopGamesWager,
  getTopGamesUWC: getTopGamesUWC,
  getJackpots: getJackpots,
  getLiveCasino: getLiveCasino,
  getLiveCasinoV2: getLiveCasinoV2
};